import React from 'react';
import { Search } from 'lucide-react';

interface BlogHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  categoryFilter: string | null;
  setCategoryFilter: (category: string | null) => void;
  categories: string[];
}

export function BlogHeader({ 
  searchQuery, 
  setSearchQuery, 
  categoryFilter, 
  setCategoryFilter,
  categories
}: BlogHeaderProps) {
  return (
    <div className="text-center mb-12">
      <h1 className="heading-1 mb-4">
        Blog Fundacji
      </h1>
      <p className="body-large max-w-3xl mx-auto mb-8">
        Najnowsze informacje, porady i historie z życia fundacji
      </p>
      
      <div className="max-w-2xl mx-auto">
        <div className="relative mb-6">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-accessible-gray-400 dark:text-white/60" aria-hidden="true" />
          <input
            type="text"
            placeholder="Szukaj na blogu..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-3 border border-accessible-gray-300 dark:border-accessible-gray-600 rounded-lg focus:ring-2 focus:ring-accessible-red-600 focus:border-transparent bg-white dark:bg-accessible-gray-700 text-accessible-gray-900 dark:text-white high-contrast:text-white form-input"
          />
        </div>
        
        {categories.length > 0 && (
          <div className="flex flex-wrap justify-center gap-2">
            <button
              onClick={() => setCategoryFilter(null)}
              className={`px-4 py-2 rounded-full transition-colors ${
                categoryFilter === null
                  ? 'bg-accessible-red-600 text-white'
                  : 'bg-accessible-gray-100 dark:bg-accessible-gray-700 text-accessible-gray-700 dark:text-white hover:bg-accessible-gray-200'
              }`}
            >
              Wszystkie
            </button>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setCategoryFilter(category)}
                className={`px-4 py-2 rounded-full transition-colors ${
                  categoryFilter === category
                    ? 'bg-accessible-red-600 text-white'
                    : 'bg-accessible-gray-100 dark:bg-accessible-gray-700 text-accessible-gray-700 dark:text-white hover:bg-accessible-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}